'use strict';

const { h } = require('phy');
const { TranslationProvider } = require('@grpn/preact-l10n');
const { Transforms } = require('@grpn/hydration');
const momentFromI18n = require('itier-datetime').momentFromI18n;
require('moment/locale/en-ie'); // eslint-disable-line
require('moment/locale/en-au'); // eslint-disable-line
require('moment/locale/en-gb'); // eslint-disable-line
require('moment/locale/de'); // eslint-disable-line
require('moment/locale/fr'); // eslint-disable-line

require('../support/bloodhound');

Transforms.add(element => {
  return h(
    TranslationProvider,
    { i18n: window.I18n, moment: momentFromI18n.bind(null, window.I18n) },
    element
  );
});

window.Groupon.Performance.pageReady();
